import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import { ref } from 'vue';
import { useStore } from 'vuex';

import { useEmitter } from '@rednex/gateway_core';
//--- Function imports

//### Service imports
//--- Service imports

//### Model imports
//--- Model imports

//### Component imports
//--- Component imports

//### External Properties
//--- External Properties

//### Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'search',
  setup(__props, { expose: __expose }) {
  __expose();

//### Function imports
const emitter = useEmitter();
const store = useStore();
//--- Setup

//### Store/Reactive Data
//--- Store/Reactive Data

//### Variables const let
const searchText = ref('');
const isLoading = ref(false);
//--- Variables const let

//### Component Lifecycle
onMounted(() => {
	searchText.value = store.getters.searchTxt;
});
//--- Component Lifecycle

//### Functions
function searchClicked() {
	isLoading.value = true;
	store.commit('setSearchTxt', searchText.value);
	emitter.emit('list-search-clicked');
	isLoading.value = false;
}

function showExtendedSearchClicked() {
	store.commit('setExtendedSearchComponentVisible', !store.getters.extendedSearchComponentVisible);
}
//--- Functions

const __returned__ = { emitter, store, searchText, isLoading, searchClicked, showExtendedSearchClicked }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})